import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import PerfectScrollbar from 'perfect-scrollbar';
import { Globals } from '../Models/UserProfile.model';
import { AppWideUser, Token } from "../Services/AppUserProfile";
import { UserService } from "../Services/user.service";
import { ROUTES } from './sidebar-routes.config';
import { SrubUpService } from '../Services/ScrubUp.service';

declare const $: any;

//Metadata
export interface RouteInfo {
    path: string;
    title: string;
    type: string;
    icontype: string;
    collapse?: string;
    children?: ChildrenItems[];
}

export interface ChildrenItems {
    path: string;
    title: string;
    ab: string;
    type?: string;
}


@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
  providers: [UserService],
})
export class SidebarComponent implements OnInit {
  impersonationStatus: boolean;
  public loading = false;
  levelNumber: number;
  public menuItems: any[];
  userName: string;
  isAuthorizedManageUsers: boolean;
  isAuthorizedProfiles: boolean;
  isAuthorizedDictionary: boolean;
  isAuthorizedDeviceAssignment: boolean;
  isAuthorizedManageDevices: boolean;
  isAuthorizedFormBuilder: boolean;
  isAuthorizedDashBoard: boolean;
  isAuthorizedMyTask: boolean;
  isAuthorizedUsers: boolean;
  isAuthorizedMonitoringPoints: boolean;
  isAuthorizedCompanyUser: boolean;
  isAuthorizedReports: boolean;
  isAuthorizedManageReaders: boolean;
  isAuthorizedCompanies: boolean;
  isAuthorizedReadersToCompany: boolean;
  isAuthorizedCorrectiveAction: boolean;
  isAuthorizedGraphicalDashboard: boolean;
  isAuthorizedAlertReason: boolean;
  isAuthorizedManageHierarchy: boolean;
  isAuthorizedManageHubs: boolean;
  isAuthorizedChangSite: boolean;
  isAuthorizedTagsToCompany: boolean;
  isAuthorizedShipmentTracking: boolean;
  isAuthorizedDashboardBeta: boolean;
  isAuthorizedManageGeofence: boolean;
  loginUserId: number;
  specialityId: number;
  showActiveLink: boolean;
  canJournalDisplay: boolean;
  canProfessionalLearningDisplay: boolean;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private cookieService: CookieService,
    private router: Router,
    private token: Token,
    private appUserDetails: AppWideUser,
    private location: Location,
    private scrubUpService: SrubUpService
  ) {
    //Globals.ImpersonationValue  = false;

    if (
      (this.appUserDetails.UserName == undefined &&
        this.token.access_token == undefined) ||
      (this.appUserDetails.UserName == null && this.token.access_token == null)
    ) {
      if (cookieService.check("AppWideUser") && cookieService.check("Token"))
        this.appUserDetails = JSON.parse(this.cookieService.get("AppWideUser"));
      this.token = JSON.parse(this.cookieService.get("Token"));
      this.specialityId = parseInt(this.cookieService.get("specialityId"));
    }
    this.getPackageTypesFeaturesByUserId();
    this.showActiveLink = false;

    this.impersonationStatus = JSON.parse(
      this.cookieService.get("impersonation")
    );
    if (this.impersonationStatus == true) {
      this.loginUserId = JSON.parse(this.cookieService.get("userId"));
    } else {
      this.loginUserId = this.appUserDetails.UserId;
    }

    this.isAuthorizedGraphicalDashboard = false;
    this.isAuthorizedManageUsers = false;
    this.isAuthorizedDeviceAssignment = false;
    this.isAuthorizedDictionary = false;
    this.isAuthorizedMyTask = false;
    this.isAuthorizedProfiles = false;
    this.isAuthorizedFormBuilder = false;
    this.isAuthorizedManageDevices = false;
    this.isAuthorizedDashBoard = false;
    this.isAuthorizedMonitoringPoints = false;
    this.isAuthorizedCompanyUser = false;
    this.isAuthorizedReports = false;
    this.isAuthorizedManageReaders = false;
    this.isAuthorizedCompanies = false;
    this.isAuthorizedReadersToCompany = false;
    this.isAuthorizedCorrectiveAction = false;
    this.isAuthorizedAlertReason = false;
    this.isAuthorizedManageHierarchy = false;
    this.isAuthorizedManageHubs = false;
    this.isAuthorizedChangSite = false;
    this.isAuthorizedTagsToCompany = false;
    this.isAuthorizedShipmentTracking = false;
    this.isAuthorizedDashboardBeta = false;
    this.isAuthorizedManageGeofence = false;

    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        if (event.urlAfterRedirects == "/layout/surgeonlist") {
          if (Globals.SpecialityId != 0) {
            this.showActiveLink = false;
            setTimeout(function () {
              var surgeonli = document.getElementById("surgeonli");
              surgeonli.classList.remove("active");
              // var specli=document.getElementById("specialityli");
              // specli.classList.add('active');
            }, 10);
          }
        }
      }
    });
    // this.UserAuthorization();
    // this.userName = this.appUserDetails.UserName;
    // if (this.token.access_token == null || this.token.access_token == undefined) {
    //     this.router.navigate(["login"]);
    // }
    // this.userName = this.appUserDetails.UserName;
  }
  isMobileMenu() {
    if ($(window).width() < 500) {
      return true;
    }
    return false;
  }

  SetSurgeonList() {
    Globals.SpecialityId = 0;
    Globals.SpecialityName = "";
    this.cookieService.set("specialityId", Globals.SpecialityId.toString());
    this.cookieService.set("specialityName", "");
    this.router
      .navigateByUrl("layout", { skipLocationChange: true })
      .then(() => this.router.navigate(["layout/surgeonlist"]));
  }

  getPackageTypesFeaturesByUserId() {
    const adminToken = JSON.parse(this.cookieService.get("Token"));
    this.scrubUpService
      .getPackageTypesFeaturesByUserId(adminToken)
      .subscribe((res) => {
        if (res.Data && res.Data.length > 0) {
          const result = res.Data.find((item) => item.UserPackageTypeID > 0);

          const { PackageTypesFeaturesList } = result;

          if (PackageTypesFeaturesList.length > 0) {
            const journal = PackageTypesFeaturesList.find(
              (item) => item.FeatureName === "journal"
            );

            if (journal) {
              this.canJournalDisplay =
                journal.FeatureValue && journal.FeatureValue == 1
                  ? true
                  : false;
            }

            const professionalLearning = PackageTypesFeaturesList.find(
              (item) => item.FeatureName === "profesionallearning"
            );

            if (professionalLearning) {
              this.canProfessionalLearningDisplay =
                professionalLearning.FeatureValue &&
                professionalLearning.FeatureValue == 1
                  ? true
                  : false;
            }
          }

          console.log(
            "this.canProfessionalLearningDisplay================",
            this.canProfessionalLearningDisplay
          );
          console.log(
            "this.canJournalDisplay================",
            this.canJournalDisplay
          );
        }
      });
  }

  ExitImpersonationMode() {
    this.appUserDetails.UserId = 1;
    this.loginUserId = this.appUserDetails.UserId;
    Globals.ImpersonationValue = false;
    this.impersonationStatus = Globals.ImpersonationValue;
    const adminToken = JSON.parse(this.cookieService.get("Token"));
    console.log("adminToken================", adminToken);
    this.cookieService.delete("Token");
    this.cookieService.delete("access-token");

    this.cookieService.set("Token", adminToken);
    this.cookieService.set(
      "access-token",
      this.cookieService.get("super-access-token")
    );
    this.cookieService.set("IsFirstTime", "true");
    this.cookieService.set("impersonation", "false");
    this.cookieService.set("userId", "");
    this.router
      .navigateByUrl("sidebar", { skipLocationChange: true })
      .then(() => this.router.navigate(["layout/speciality"]));
  }

  public UserAuthorization() {
    this.userName = this.appUserDetails.Email;
    this.isAuthorizedChangSite = false;
    this.isAuthorizedDictionary = false;
    this.isAuthorizedManageDevices = false;
    this.isAuthorizedMyTask = false;
    this.isAuthorizedFormBuilder = false;
    this.isAuthorizedManageUsers = false;
    this.isAuthorizedProfiles = false;
    this.isAuthorizedDeviceAssignment = false;
    this.isAuthorizedDashBoard = false;
    this.isAuthorizedMonitoringPoints = false;
    this.isAuthorizedCompanyUser = false;
    this.isAuthorizedReports = false;
    this.isAuthorizedManageReaders = false;
    this.isAuthorizedCompanies = false;
    this.isAuthorizedReadersToCompany = false;
    this.isAuthorizedCorrectiveAction = false;
    this.isAuthorizedAlertReason = false;
    this.isAuthorizedMonitoringPoints = false;
    this.isAuthorizedTagsToCompany = false;
    this.isAuthorizedShipmentTracking = false;
    this.isAuthorizedManageGeofence = false;

    // this.appUserDetails.Roles.forEach(role => {
    //     if (role == "CCPAdmin") {
    //         if (this.appUserDetails.LevelNumber > 1 || (this.appUserDetails.LevelNumber == undefined || this.appUserDetails.LevelNumber == null)) {
    //             this.isAuthorizedAlertReason = true;
    //             this.isAuthorizedCorrectiveAction = true;
    //             this.isAuthorizedManageHierarchy = true;
    //             this.isAuthorizedCompanyUser = true;
    //             this.isAuthorizedManageUsers = true;
    //             this.isAuthorizedDashboardBeta=true;

    //         }
    //         else {
    //             this.userName = this.appUserDetails.Email;
    //             // this.isAuthorizedReadersToCompany = true;
    //             // this.isAuthorizedGraphicalDashboard = true;
    //             // this.isAuthorizedProfiles = true;
    //             // this.isAuthorizedDashBoard = true;
    //             this.isAuthorizedMonitoringPoints = true;
    //             // this.isAuthorizedCompanyUser = true;
    //             // this.isAuthorizedReports = true;
    //             this.isAuthorizedAlertReason = true;
    //             // this.isAuthorizedCorrectiveAction = true;
    //             // this.isAuthorizedManageReaders = true;
    //             // this.isAuthorizedTagsToCompany = true;
    //             // this.isAuthorizedCompanies = true;
    //             this.isAuthorizedManageUsers = true;
    //             // this.isAuthorizedShipmentTracking = true;
    //             // this.isAuthorizedManageGeofence=true;
    //         }
    //     }

    // });
  }

  SidebarNavigation() {
    this.router.navigateByUrl("/layout/my-task");
  }

  NavigateToChangePassword() {
    this.router.navigate(["change-password"]);
  }

  SignOut() {
    this.router.navigate(["login"]);
    this.location.replaceState("/");
    window.document.cookie.split(";").forEach(function (c) {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    this.appUserDetails = null;
    this.token.access_token = null;
    this.token.userName = null;
    this.token.expires_in = null;
    this.token.token_type = null;
    //====================Impersonation==============>
    this.appUserDetails.UserId = 1;
    this.loginUserId = this.appUserDetails.UserId;
    Globals.ImpersonationValue = false;
    this.impersonationStatus = Globals.ImpersonationValue;
    //<===============================================
  }

  ngOnInit() {
    this.menuItems = ROUTES.filter((menuItem) => menuItem);
    //console.log(this.menuItems);
  }
  updatePS(): void {
    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      const elemSidebar = <HTMLElement>(
        document.querySelector(".sidebar .sidebar-wrapper")
      );
      let ps = new PerfectScrollbar(elemSidebar, {
        wheelSpeed: 2,
        suppressScrollX: true,
      });
    }
  }
  isMac(): boolean {
    let bool = false;
    if (
      navigator.platform.toUpperCase().indexOf("MAC") >= 0 ||
      navigator.platform.toUpperCase().indexOf("IPAD") >= 0
    ) {
      bool = true;
    }
    return bool;
  }
  open() {
    var $ddlBtn = $("#my-custom-ddl");
    // $ddlBtn.on("click", function(){
    var expanded = /true/i.test($ddlBtn.attr("aria-expanded"));
    $ddlBtn.attr("aria-expanded", !expanded).parent().toggleClass("open");
    // });
  }
}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/sidebar/sidebar.component.ts